import { imageUploadActionTypes } from './ImageUpload.actionTypes';
// Initial state
const initialState = {
  isLoading: false,
};

// Reducer function
const imageUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case imageUploadActionTypes.START_IMAGE_UPLOAD:
      return {
        ...state,
        isLoading: true,
      };
    case imageUploadActionTypes.IMAGE_UPLOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case imageUploadActionTypes.IMAGE_UPLOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default imageUploadReducer;
